"use client";

import { createBrowserClient, type CookieOptionsWithName } from "@supabase/ssr";
import type { Database } from "./database.types";

/**
 * Supabase-Client für Code, der im Browser läuft (Client Components,
 * Form-Handler etc.). Liest Anon-Key aus dem öffentlichen Bundle und
 * synchronisiert Sessions über sichere httpOnly-Cookies (von der
 * Server-Seite gesetzt). Session-Cookies sind:
 *   sb-<project>-auth-token       (geschützt)
 *   sb-<project>-auth-token-code-verifier
 */
const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || "";

export function getSupabaseBrowser() {
  return createBrowserClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
    // Standardeinstellungen reichen – die expliziten Optionen unten machen
    // klar, was wir wollen.
    cookieOptions: {
      sameSite: "lax",
      secure: typeof window !== "undefined" && window.location.protocol === "https:",
    } satisfies CookieOptionsWithName,
  });
}
